import config from '@sdk/config/appConfig';

import { SUBSCRIPTION_LEVELS } from '../../account/constants';

import premiumTrialEndModalUrl from './premiumTrialEndModal.html';
import premiumToastTrialEndModalUrl from './premiumToastTrialEndModal.html';

const PURCHASE_STATE_NAME = 'account.overview.purchase';

class PremiumTrialEndModalHandlerCtrl {
  SUBSCRIPTION_LEVELS = SUBSCRIPTION_LEVELS;

  constructor(
    Authentication,
    Utils,
    SlingAnalytics,
    SubscriptionUtils,
    $uibModal,
    $state,
    $timeout,
    $scope
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      Utils,
      SlingAnalytics,
      SubscriptionUtils,
      $uibModal,
      $state,
      $timeout,
      $scope,
    });
  }

  $onInit() {
    if (this.shouldDisplayModal()) {
      this.displayModal();
    } else {
      this.unwatch = this.$scope.$watch('ctrl.Authentication.user.org.isPremium', () => {
        if (this.shouldDisplayModal()) {
          this.displayModal();
          this.unwatch();
        }
      });
    }
  }

  $onDestroy() {
    this.unwatch();
  }

  shouldDisplayModal() {
    if (!this.Authentication.user) return;

    const { premiumTrialStartDate, subscriptionExpiredDate, isPremium } =
      this.Authentication.user.org;
    const { premiumTrialEndModalShown } = this.Authentication.user.settings.clientFlags;

    return (
      this.Authentication.user?.isManager &&
      !isPremium &&
      premiumTrialStartDate &&
      subscriptionExpiredDate >= new Date(this.Authentication.user.joinedAt) &&
      !premiumTrialEndModalShown &&
      this.$state.current.name !== PURCHASE_STATE_NAME
    );
  }

  async displayModal() {
    const { premiumTrialEndPlanSelected } = this.SlingAnalytics.analyticsEvents;

    await this.$timeout();

    const plan = await this.$uibModal.open({
      windowClass: 'sling-animate modal-auto-width',
      templateUrl: this.Authentication.user.org.isToastBilling
        ? premiumToastTrialEndModalUrl
        : premiumTrialEndModalUrl,
      backdrop: 'static',
      keyboard: false,
      controllerAs: 'ctrl',
      controller() {
        this.SUBSCRIPTION_LEVELS = SUBSCRIPTION_LEVELS;
      },
    }).result;
    this.Authentication.user.settings.clientFlags.premiumTrialEndModalShown = true;
    this.Authentication.user.settings.clientFlags.premiumTrialEndPlanLevelSelected = plan;
    this.Authentication.syncSettings();

    if (this.Authentication.user.org.isToastBilling) {
      this.SlingAnalytics.track(
        premiumTrialEndPlanSelected,
        plan ? 'scheduling_pro' : 'scheduling_lite'
      );
      if (plan) {
        const url = new URL(config.TOAST_SALES_URL);
        url.searchParams.append('utm_source', 'rd-ec');
        url.searchParams.append('utm_medium', 'toastweb-native');
        url.searchParams.append('utm_campaign', 'customer-ec-sling-expired-free-trial-mar-23');
        window.location.href = url.toString();
      } else {
        this.$state.go('account.overview.billing');
      }
      return;
    }

    this.SlingAnalytics.track(
      premiumTrialEndPlanSelected,
      {
        0: 'free',
        1: 'premium_2019_02', // new premium
        2: 'premium_2018', // old premium
        3: 'business_2019_02',
      }[plan]
    );
    if (plan){
    this.$state.go(PURCHASE_STATE_NAME, { plan });
  }}
}

export default {
  controller: PremiumTrialEndModalHandlerCtrl,
  controllerAs: 'ctrl',
};
